import classNames from "classnames";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { AscEventType } from "../AscCalendarEvents.types";
import styles from "./AscCalendarEventItem.module.scss";
dayjs.extend(relativeTime);

export interface AscCalendarEventItemProps {
  className?: string;
  title: string;
  date: string;
  type: AscEventType;
  onEventClick?: (date: string) => void;
}

export default function AscCalendarEventItem({
  className,
  title,
  date,
  type,
  onEventClick,
}: AscCalendarEventItemProps) {
  function handleClick() {
    onEventClick?.(date);
  }

  function getStyles(color?: string): React.CSSProperties {
    return { "--typeColor": color || "var(--brandRed)" } as React.CSSProperties;
  }
  return (
    <div
      data-testid="asc-calendar-event-item"
      className={classNames(
        styles.ground,

        className
      )}
      style={getStyles(type?.color)}
      onClick={handleClick}
    >
      <div className={styles.title}>{title}</div>
      <div className={styles.date}>
        {dayjs(date).format("D MMMM, YYYY [at] h:mm A")}
      </div>
      <div className={styles.mask} />
    </div>
  );
}
